import Mutations from '../../odata/mutations';

export default { ...new Mutations('solutionAttachment'), ...new Mutations('solutionAttachments') };
